import { buildTheme } from './DefaultBaseTheme';

export const Colors = {
    strokeColor: '#ccc',
    defaultFillColor: '#fff',
    textColor: '#ccc',
    arrowFillColor: '#ccc',
    rectangleFillColor: '#ede7f6',
    rectangleDotFillColor: '#ede7f6',
    functionFillColor: '#f1f8e9',
    rootCircleFillColor: '#fffde7',
    loopFillColor: '#e3f2fd',
    conditionFillColor: '#f3e5f5',
    destructedNodeFillColor: '#fff8e1',
    classFillColor: '#e0f2f1',
    debuggerFillColor: '#ffebee',
    exportFillColor: '#e1f5fe',
    throwFillColor: '#fce4ec',
    tryFillColor: '#fff8e1',
    objectFillColor: '#f9fbe7',
    callFillColor: '#f9fbe7',
    debugModeFillColor: '#666'
};

export default buildTheme(Colors);



// WEBPACK FOOTER //
// ./src/render/svg/appearance/themes/Blurred.js